var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShikumLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9337 32.2446C16.1427 26.8091 14.4721 16.2816 9.67285 12.7566C14.2593 13.7844 15.8645 17.8648 18.6655 17.7837C20.6309 17.7345 22.1305 15.2692 22.9 11.9238C22.6378 21.031 18.174 28.8982 11.9337 32.2446Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.354 15.8893C19.4676 15.8893 20.3685 14.8611 20.3685 13.6204C20.3685 12.3638 19.4676 11.3516 18.354 11.3516C17.2561 11.3516 16.3389 12.3638 16.3389 13.6204C16.3389 14.8611 17.2561 15.8893 18.354 15.8893Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09708 34.7957C9.09708 34.7957 16.756 26.8918 11.7286 17.5349C9.66337 18.658 12.5215 22.275 11.3612 23.2702C5.65062 18.8494 10.818 13.5143 7.89709 12.1406C6.36013 15.9628 5.97749 20.908 8.54864 24.8969C11.7929 29.9305 9.09708 34.7957 9.09708 34.7957Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0205 32.1852C13.0205 32.1852 19.506 30.0473 22.4937 20.0471C24.6408 20.5123 23.7537 23.6285 22.1201 25.5356C27.1127 24.5793 24.0468 15.4595 26.863 16.4455C30.2073 31.8674 13.0205 32.1852 13.0205 32.1852Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08546 35.6848C3.95627 34.868 2.04374 30.7478 1.87946 26.5271C1.83313 25.3285 1.86076 14.7637 1.86076 14.7637L0.0767874 16.3625C0.0767874 16.3625 -0.00358239 25.6181 0.00012439 28.5743C0.153282 33.5249 3.84085 36.3537 7.38319 36.9613L8.08546 35.6848Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8959 16.3251L32.1086 14.7305C32.1086 14.7305 32.1601 25.2955 32.116 26.4939C31.9502 31.0123 29.7831 35.4226 25.0261 35.792L17.0152 35.8633C17.0152 35.8633 13.7472 36.1689 8.99005 35.8096C8.91744 35.8041 8.85054 35.7893 8.77944 35.7817L7.60254 36.9959C8.07195 37.0642 8.5385 37.098 8.99123 37.0876L25.0276 37.0698C28.9629 37.1514 33.8361 34.2476 34 28.5371C33.997 25.5805 33.8959 16.3251 33.8959 16.3251Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26138 33.1572C6.10017 31.7508 5.21644 27.8596 5.21509 26.7784C5.21391 25.4987 5.11316 11.2656 5.11316 11.2656L3.32295 12.9695C3.32295 12.9695 3.30762 23.9677 3.31115 27.1209C3.26196 30.9607 6.21171 33.6644 8.78843 34.3892C8.89795 34.1639 9.08244 33.7413 9.26138 33.1572Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6424 12.9405L28.8492 11.2402C28.8492 11.2402 28.7793 25.4735 28.7806 26.7531C28.7823 28.0309 27.5725 33.249 22.8024 33.6428L11.2098 33.6556C11.0137 33.64 10.8326 33.6041 10.6482 33.5723C10.3554 33.9885 10.0952 34.3257 9.88867 34.5782C9.9591 34.5815 10.0324 34.5916 10.1011 34.5916L23.9143 34.5761C26.6662 34.5733 30.7535 31.6087 30.6859 27.0914C30.682 23.9385 30.6424 12.9405 30.6424 12.9405Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47197 11.9704L7.65293 11.5203L8.0932 11.7273C8.31072 11.8295 8.48847 11.9507 8.63995 12.0847C8.80153 12.1955 9.02191 12.347 9.28358 12.5249C9.34188 12.4267 9.43387 12.3596 9.53766 12.3255C9.56159 9.38757 9.5813 7.11719 9.5813 7.11719L6.90551 9.38589C6.90551 9.38589 6.9045 11.1853 6.90332 13.6176C7.06457 13.0667 7.25209 12.5169 7.47197 11.9704Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8836 19.8458C24.8974 19.6771 24.9113 19.5078 24.9237 19.3438C25.0445 17.788 25.1397 16.5594 25.8599 16.0918C26.18 15.8836 26.5692 15.8576 27.0155 16.014L27.07 16.033C27.0609 12.6107 27.0523 9.68122 27.0523 9.68122L24.3716 7.19141C24.3716 7.19141 24.4482 14.249 24.5001 19.5592C24.6471 19.6672 24.78 19.7666 24.8836 19.8458Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4448 27.2749C23.4335 29.8059 20.4858 31.1423 17.9658 31.8489L22.3705 31.8439C24.3944 31.8419 27.0951 29.2856 27.0906 25.25C27.0902 24.9679 27.0899 24.6461 27.0892 24.2969C26.7057 25.3808 26.1593 26.3755 25.4448 27.2749Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65399 31.1513C9.81068 29.4645 9.57278 27.332 8.16302 25.1457C7.63211 24.3212 7.21442 23.4233 6.90137 22.4766C6.90154 23.5826 6.90204 24.5544 6.90288 25.2743C6.90575 28.0556 8.192 30.1305 9.65399 31.1513Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2948 15.4737C15.6561 15.785 15.9946 16.0724 16.3241 16.3281L16.3231 15.168C16.0458 14.7278 15.881 14.1952 15.881 13.6199C15.881 13.0464 16.0439 12.5157 16.3196 12.0763L16.3061 0.00195312L11.5215 5.12227L11.5301 12.8921C13.1023 13.5885 14.2906 14.6094 15.2948 15.4737Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3544 10.8944C19.7181 10.8944 20.8273 12.1166 20.8273 13.6196C20.8273 15.1226 19.7181 16.3455 18.3544 16.3455C18.1072 16.3455 17.8735 16.2933 17.6482 16.2184L17.6489 17.132C17.9758 17.2605 18.306 17.3362 18.6523 17.3258C20.2364 17.2865 21.6457 15.2589 22.4335 11.8987L22.426 5.10991L17.6299 0L17.6422 11.0232C17.8691 10.9475 18.1052 10.8944 18.3544 10.8944Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShikumLogo);
export default __webpack_public_path__ + "static/media/ShikumLogo.b5e4c4d25e2da21d03e3b898dd187c70.svg";
export { ForwardRef as ReactComponent };